import { render, staticRenderFns } from "./TvingPartnerVoucherList.vue?vue&type=template&id=51db1378&scoped=true"
import script from "./TvingPartnerVoucherList.vue?vue&type=script&setup=true&lang=js"
export * from "./TvingPartnerVoucherList.vue?vue&type=script&setup=true&lang=js"
import style0 from "@/assets/scss/category/ticket.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./TvingPartnerVoucherList.vue?vue&type=style&index=1&id=51db1378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51db1378",
  null
  
)

export default component.exports